import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { getParent, addClass, hasClass } from '@fretadao/f-js-dom';
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';

application.register(
  'match-filter',
  class extends Controller {
    static values = { hint: { type: String, default: 'Utilize % para combinar informações' } };

    connect() {
      this._applySelect();
      this._addHint();
    }

    _parent() {
      return getParent(this.element);
    }

    _isFilter() {
      return this.element.closest('.filter_select');
    }

    _applySelect() {
      if(hasClass(this.element, 'select2-hidden-accessible')) return;

      // need to manually add the class `default-select` on the field
      $(this.element).select2({
        placeholder: '',
        width: this._isFilter() ? 'resolve' : '80%',
        allowClear: true,
        matcher: (params, data) => {
          if (!params.term?.trim()) return data;

          const termInRegex = new RegExp(params.term.replaceAll('%', '.*'));

          return termInRegex.test(data.text) ? data : null;
        }
      })
        .on('select2:select', this._dispachChangeEvent.bind(this))
        .on('select2:clear', this._dispachChangeEvent.bind(this));
    }

    _addHint() {
      if (this._parent().querySelector('.inline-hints')) return;

      const hint = document.createElement('p');
      hint.textContent = this.hintValue;
      addClass(hint, 'inline-hints');
      this._parent().append(hint);
    }

    _dispachChangeEvent() {
      this.element.dispatchEvent(new Event('change'));
    }
  }
)
